import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import Text from 'src/components/text';

interface IntegrationCardProps {
  title: string;
  subTitle?: string;
  iconUrl: string;
  status?: React.ReactNode | undefined,
  type: 'integration' | 'capability' | 'notify';
  actionType?: React.ReactNode;
  className?: string;
  handleClick?: () => void;
  cursor?: "default" | "pointer";
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({  cursor = "default",className, handleClick, title, subTitle, type, actionType, iconUrl, status}) => {

  return (
    <div onClick={handleClick && handleClick} className={cx(styles.card, className, {
      [styles.capabilityCard]: type === 'capability',
    })}  style={{ cursor }}>
       <div className={cx(styles.header)}>
         <img src={iconUrl} alt="integration-icon" className={styles.icon} />
         {status && status}
        </div>
      <h3 className={styles.title}>{title}</h3>
      <Text className={styles.subTitle} lines={2} text={subTitle} tooltip={{ placement: "top" }} />

       { actionType && <div className={styles.contentWrapper}>
        {actionType}
      </div> }
    </div>
  );
};

export const NotifyAction = ({
  percentage,
  handleNotifyUser,
  showNotifyButton
}: {
  percentage: number;
  handleNotifyUser?: () => void;
  showNotifyButton? : boolean;
}) => {
  return (
    <>
      <div className={cx(styles.progressWrapper,{
        [styles.animate] : showNotifyButton && handleNotifyUser != null
      })}>
        <div className={styles.progressContainer}>
          <div
            className={styles.progressBar}
            style={{ width: `${percentage}%` }}
          />
          <div className={styles.progressBarFill} />
        </div>
        <span className={styles.percentageText}>{percentage}%</span>
      </div>
      {showNotifyButton && handleNotifyUser && <div
        className={styles.textWrapper}
        onClick={() => handleNotifyUser && handleNotifyUser()}
      >
        <i className="paperflite-notifications" /> Notify user
      </div>}
    </>
  );
};

export const IntegrationStatus = ({
  enabled,
  reauthenticate,
  handleClick
}: {
  enabled: boolean;
  reauthenticate: boolean;
  handleClick: () => void;
}) => {
  return (
    <div className={cx(styles.integrationStatus, {
      [styles.inactive]: !reauthenticate && !enabled,
    })}>
      <i className={cx(styles.statusIcon, {
        "paperflite-tick": !reauthenticate && enabled,
        "paperflite-right-arrow": reauthenticate || !enabled,
      })} />
      <span className={styles.status} onClick={handleClick}> {reauthenticate ? "Reauthenticate" : (enabled ? "Activated" : "Activate")}</span>
    </div>
  );
}

export const ToggleStatus = ({
  enabled,
  onToggle,
}: {
  enabled: boolean;
  onToggle: () => void;
}) => {
  return (
    <div className={cx(styles.toggleStatus, {
      [styles.inactive]: !enabled,
    })} onClick={onToggle}>
      <div className={cx(styles.toggle, {
        [styles.toggleOn]: enabled,
        [styles.toggleOff]: !enabled,
      })}>
        <div className={cx(styles.toggleSlider, {
          [styles.sliderOn]: enabled,
          [styles.sliderOff]: !enabled
        })} />
      </div>
      <span className={cx(styles.toggleText, {
        [styles.disabledText]: !enabled,
      })}>
        {enabled ? "Selected" : "Select"}
      </span>
    </div>
  );
}

export default IntegrationCard;
